// extracted by mini-css-extract-plugin
export default {"mainBox":"FavMusic_mainBox__L91wr","bigBox":"FavMusic_bigBox__aO5-B","songs":"FavMusic_songs__M1Pzr"};